common.View.create('website::layouts.main.Secondmenu', {

    onDOMLoad()
    {
        this.initSecondMenu();
        this.initCloseSecondMenu();
    },

    initSecondMenu() {
        this.element.find('.secondmenu')
            .on('click', (event) => {
                // Set as active
                $(event.currentTarget).toggleClass('is-active');

                // Fade menu
                this.element.find('.trigger').fadeIn('fast');
            });
    },

    initCloseSecondMenu() {
        this.element.find('.close_second_menu')
            .on('click', () => {
                // Remove active
                $('.secondmenu').removeClass('is-active');

                // Fade menu
                this.element.find('.trigger').fadeOut('fast');
            });
    },

});
